import { useEffect } from 'react';

/**
 * Keeps `<title>` and `<meta name="description">` in sync with the active route.
 *
 * Updates the tags already present in index.html rather than appending new
 * ones, so the document never ends up with two titles.
 */
export function useDocumentMeta({ title, description }) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  useEffect(() => {
    if (!description) return;

    let tag = document.head.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'description');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', description);
  }, [description]);
}

export default useDocumentMeta;
